import { render, staticRenderFns } from "./approveDialog.vue?vue&type=template&id=6dacbfc9&scoped=true"
import script from "./approveDialog.vue?vue&type=script&lang=js"
export * from "./approveDialog.vue?vue&type=script&lang=js"
import style0 from "./approveDialog.vue?vue&type=style&index=0&id=6dacbfc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dacbfc9",
  null
  
)

export default component.exports